import { Controller } from '@hotwired/stimulus';
import { useModal } from '../../js/stimulus_use/use-modal';

export default class extends Controller {
    static targets = ['languagesSelect', 'list'];

    connect() {
        this.selectedValues = [];
    }

    openModal() {
        $(this.element).modal('show');

        const spans = document.querySelectorAll('#languages-paragraph span');

        this.selectedValues = Array.from(spans).map(span =>
            span.getAttribute('data-term-id')
        );

        this.render()
        this.languagesSelectTarget.tomselect.clear(true);
    }

    onChange(e) {
        const selectedValue = e.target.value;

        if (!this.selectedValues.includes(selectedValue)) {
            this.selectedValues.push(selectedValue);
        }

        this.render();
        this.languagesSelectTarget.tomselect.clear(true);
    }

    render() {
        this.listTarget.innerHTML = '';

        const optionMap = new Map(
            Array.from(this.languagesSelectTarget.options).map(option => [option.value, option.textContent])
        );

        this.selectedValues.forEach(val => {
            const wrapper = document.createElement('span')
            wrapper.className = 'badge badge-lg bg-primary bg-light-blue border-0 pe-2'

            const label = document.createElement('span')
            label.textContent = optionMap.get(val)
            label.className = 'me-2'

            const close = document.createElement('button')
            close.className = 'border-0 m-0 bg-transparent text-primary p-0'
            close.type = 'button'
            close.innerHTML = 'x'

            close.addEventListener('click', () => {
                this.selectedValues = this.selectedValues.filter(v => v !== val)
                this.render()
            })

            wrapper.appendChild(label)
            wrapper.appendChild(close)
            this.listTarget.appendChild(wrapper)
        });
    }

    save(event) {
        event.preventDefault();
        const field = 'languages';
        const value = this.selectedValues.slice();

        const data = {
            field: field,
            value: value.join(","),
        };

        showPreloader();

        $.post(routes['app_profile_edit'], data, async (result) => {
            if (result.status) {
                window.dataLayer.push({
                    event: 'dataLayer.gaEvent',
                    gaEvent: {
                        category: 'Account',
                        action: field + ' | Success',
                        label: typeof GA_EVENT_LABEL !== 'undefined' ? GA_EVENT_LABEL : '',
                    },
                });

                window.location.reload();
            } else {
                addAlert('danger', translations['profile.An unknown error occurred.']);
                hidePreloader();
            }
        }).fail(function() {
            dataLayer.push({
                event: 'dataLayer.gaEvent',
                gaEvent: {
                    'category': 'Account',
                    'action': field + ' | Failure',
                    'label': GA_EVENT_LABEL,
                },
            });
            addAlert('danger', translations['profile.An unknown error occurred.']);
            hidePreloader();
        });
    }
}
